'use strict';

var isDate = require('lodash.isdate'),
    stringUtils = require('../string'),
    pattern = /^(\d{4})-(\d{1,2})-(\d{1,2})/;

module.exports = {
  parse: function parse(value) {
    if (typeof value !== 'string') {
      throw new Error('value is required string');
    }

    var match = pattern.exec(value);

    if (match == null) {
      throw new Error('value is invalid');
    }

    // If overflowing values are passed to Date constructor, it extrapolates them
    // instead of throwing error. (E.g., passing in {2016, 5, 40} will produce
    // 2016 June 9.) We don't won't to allow that, though. So use the constructor,
    // but then compare the resulting Date to the parsed values.

    var year = parseInt(match[1]),
        month = parseInt(match[2]) - 1,
        date = parseInt(match[3]),
        parsed = new Date(year, month, date);

    if (year !== parsed.getFullYear() || month !== parsed.getMonth() || date !== parsed.getDate()) {
      throw new Error('value is invalid');
    }

    return parsed;
  },

  format: function format(value) {
    if (!isDate(value)) {
      throw new Error('value is required date');
    }

    return [value.getFullYear(), stringUtils.pad(value.getMonth() + 1, 2), stringUtils.pad(value.getDate(), 2)].join('-');
  },

  reformat: function reformat(value) {
    return this.format(this.parse(value));
  },

  today: function today() {
    return this.format(new Date());
  }
};